export class WaitForCSS {
  constructor() {
    return {
      link: function(scope, element, attr) {
        scope.$watch(() => {
          scope.slidebars = new $.slidebars();
        });
      }
    }
  }
}
